/**
 * Les pays proposés par le formulaire d'un client.
 *
 * LISTE FERMÉE À L'ÉCRAN, BASE OUVERTE. Décidé le 03/09/2026 : le déroulant
 * n'offre que ces valeurs, mais `clients.pays` reste un `text` sans
 * contrainte — vérifié dans la migration 20260902153000_annuaire_clients.sql,
 * ligne `pays text not null default 'France'`. La règle n'existe donc QUE
 * dans l'interface : un appel direct à l'API accepterait n'importe quel texte.
 * On le dit ici plutôt que de laisser croire le contraire.
 *
 * La forme correcte serait une table de référence `pays` (code ISO + nom) et
 * une clé étrangère. Elle viendra quand elle servira à quelque chose — zones de
 * transport, douane. Aujourd'hui aucun calcul ne s'appuie sur le pays.
 *
 * C'est le NOM qui est enregistré, pas le code ISO, parce que c'est ce que la
 * colonne contient déjà. Le jour de la table de référence, il faudra rapprocher
 * les noms des codes : c'est le prix de ce choix, et il est connu.
 *
 * Liste engendrée une fois par `Intl.DisplayNames(['fr'], { type: 'region' })`
 * sur les codes à deux lettres, puis FIGÉE ICI. Elle n'est pas calculée à
 * l'exécution : deux navigateurs pourraient rendre des noms un peu différents,
 * et une liste fermée dont les valeurs changent d'une machine à l'autre n'est
 * plus fermée du tout.
 *
 * Deux nettoyages, tous deux constatés en engendrant la liste :
 *   - sept agrégats retirés — Union européenne, zone euro, Nations Unies,
 *     régions éloignées de l'Océanie, région inconnue et deux locales d'essai ;
 *   - quinze DOUBLONS retirés. ICU reconnaît encore des codes historiques qui
 *     rendent le nom d'aujourd'hui : HV la Haute-Volta pour le Burkina Faso,
 *     DD la RDA pour l'Allemagne, SU l'URSS pour la Russie, YU la Yougoslavie
 *     pour la Serbie, RH la Rhodésie pour le Zimbabwe, FX la France
 *     métropolitaine pour la France. Sans ce nettoyage, le déroulant proposait
 *     deux fois « Zimbabwe ».
 *
 * France en premier : c'est le pays de presque tous les clients, et la valeur
 * par défaut de la colonne.
 */
export const PAYS: readonly string[] = [
  'France',
  'Afghanistan',
  'Afrique du Sud',
  'Albanie',
  'Algérie',
  'Allemagne',
  'Andorre',
  'Angola',
  'Anguilla',
  'Antarctique',
  'Antigua-et-Barbuda',
  'Arabie saoudite',
  'Argentine',
  'Arménie',
  'Aruba',
  'Australie',
  'Autriche',
  'Azerbaïdjan',
  'Bahamas',
  'Bahreïn',
  'Bangladesh',
  'Barbade',
  'Belgique',
  'Belize',
  'Bénin',
  'Bermudes',
  'Bhoutan',
  'Biélorussie',
  'Bolivie',
  'Bosnie-Herzégovine',
  'Botswana',
  'Brésil',
  'Brunei',
  'Bulgarie',
  'Burkina Faso',
  'Burundi',
  'Cambodge',
  'Cameroun',
  'Canada',
  'Cap-Vert',
  'Ceuta et Melilla',
  'Chili',
  'Chine',
  'Chypre',
  'Colombie',
  'Comores',
  'Congo-Brazzaville',
  'Congo-Kinshasa',
  'Corée du Nord',
  'Corée du Sud',
  'Costa Rica',
  'Côte d’Ivoire',
  'Croatie',
  'Cuba',
  'Curaçao',
  'Danemark',
  'Diego Garcia',
  'Djibouti',
  'Dominique',
  'Égypte',
  'Émirats arabes unis',
  'Équateur',
  'Érythrée',
  'Espagne',
  'Estonie',
  'Eswatini',
  'État de la Cité du Vatican',
  'États-Unis',
  'Éthiopie',
  'Fidji',
  'Finlande',
  'Gabon',
  'Gambie',
  'Géorgie',
  'Géorgie du Sud-et-les Îles Sandwich du Sud',
  'Ghana',
  'Gibraltar',
  'Grèce',
  'Grenade',
  'Groenland',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernesey',
  'Guinée',
  'Guinée équatoriale',
  'Guinée-Bissau',
  'Guyana',
  'Guyane française',
  'Haïti',
  'Honduras',
  'Hongrie',
  'Île Bouvet',
  'Île Christmas',
  'Île Clipperton',
  'Île de l’Ascension',
  'Île de Man',
  'Île Norfolk',
  'Îles Åland',
  'Îles Caïmans',
  'Îles Canaries',
  'Îles Cocos',
  'Îles Cook',
  'Îles Féroé',
  'Îles Heard-et-MacDonald',
  'Îles Malouines',
  'Îles Mariannes du Nord',
  'Îles Marshall',
  'Îles mineures éloignées des États-Unis',
  'Îles Pitcairn',
  'Îles Salomon',
  'Îles Turques-et-Caïques',
  'Îles Vierges britanniques',
  'Îles Vierges des États-Unis',
  'Inde',
  'Indonésie',
  'Irak',
  'Iran',
  'Irlande',
  'Islande',
  'Israël',
  'Italie',
  'Jamaïque',
  'Japon',
  'Jersey',
  'Jordanie',
  'Kazakhstan',
  'Kenya',
  'Kirghizstan',
  'Kiribati',
  'Kosovo',
  'Koweït',
  'La Réunion',
  'Laos',
  'Lesotho',
  'Lettonie',
  'Liban',
  'Liberia',
  'Libye',
  'Liechtenstein',
  'Lituanie',
  'Luxembourg',
  'Macédoine du Nord',
  'Madagascar',
  'Malaisie',
  'Malawi',
  'Maldives',
  'Mali',
  'Malte',
  'Maroc',
  'Martinique',
  'Maurice',
  'Mauritanie',
  'Mayotte',
  'Mexique',
  'Micronésie',
  'Moldavie',
  'Monaco',
  'Mongolie',
  'Monténégro',
  'Montserrat',
  'Mozambique',
  'Myanmar (Birmanie)',
  'Namibie',
  'Nauru',
  'Népal',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norvège',
  'Nouvelle-Calédonie',
  'Nouvelle-Zélande',
  'Oman',
  'Ouganda',
  'Ouzbékistan',
  'Pakistan',
  'Palaos',
  'Panama',
  'Papouasie-Nouvelle-Guinée',
  'Paraguay',
  'Pays-Bas',
  'Pays-Bas caribéens',
  'Pérou',
  'Philippines',
  'Pologne',
  'Polynésie française',
  'Porto Rico',
  'Portugal',
  'Qatar',
  'R.A.S. chinoise de Hong Kong',
  'R.A.S. chinoise de Macao',
  'République centrafricaine',
  'République dominicaine',
  'Roumanie',
  'Royaume-Uni',
  'Russie',
  'Rwanda',
  'Sahara occidental',
  'Saint-Barthélemy',
  'Saint-Christophe-et-Niévès',
  'Saint-Marin',
  'Saint-Martin',
  'Saint-Martin (partie néerlandaise)',
  'Saint-Pierre-et-Miquelon',
  'Saint-Vincent-et-les Grenadines',
  'Sainte-Hélène',
  'Sainte-Lucie',
  'Salvador',
  'Samoa',
  'Samoa américaines',
  'Sao Tomé-et-Principe',
  'Sénégal',
  'Serbie',
  'Sercq',
  'Seychelles',
  'Sierra Leone',
  'Singapour',
  'Slovaquie',
  'Slovénie',
  'Somalie',
  'Soudan',
  'Soudan du Sud',
  'Sri Lanka',
  'Suède',
  'Suisse',
  'Suriname',
  'Svalbard et Jan Mayen',
  'Syrie',
  'Tadjikistan',
  'Taïwan',
  'Tanzanie',
  'Tchad',
  'Tchéquie',
  'Terres australes françaises',
  'Territoire britannique de l’océan Indien',
  'Territoires palestiniens',
  'Thaïlande',
  'Timor oriental',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinité-et-Tobago',
  'Tristan da Cunha',
  'Tunisie',
  'Turkménistan',
  'Turquie',
  'Tuvalu',
  'Ukraine',
  'Uruguay',
  'Vanuatu',
  'Venezuela',
  'Viêt Nam',
  'Wallis-et-Futuna',
  'Yémen',
  'Zambie',
  'Zimbabwe',
];
